export const CLOUD_VEN_PAGE_CONST = {
    localStorage: {
        sidebarCollapsedKey: 'cloudVenSidebarCollapsed',
    },
    collapsedWidth: 40,
    expandedWidth: 260,
    tabContentHeight: 'calc(100vh - 156px)', // Adjusted to match the height of the sidebar content
};
